import { Box, Button, Center, Flex, Spacer, Text } from '@chakra-ui/react';

export type PageProps = {
  title: string;
  subtitle?: string;
  image?: string;
  onClick?: () => void;
  value?: string;
  isSelected?: boolean;
};

const RegularButton = ({
  title,
  subtitle,
  image,
  onClick,
  value,
  isSelected,
}: PageProps) => {
  return (
    <Center>
      <Button
        aria-label={title}
        borderRadius={'2xl'}
        width={'100%'}
        bgColor={isSelected ? '#2C5282' : 'dripPrimaryFill'}
        color={'white'}
        minHeight={'60px'}
        _hover={{}}
        _focus={{}}
        _active={{}}
        onClick={onClick}
        value={value}
        marginBottom={'5'}
        marginLeft={'7'}
        marginRight={'7'}
        boxShadow="lg"
      >
        <Flex direction={'column'}>
          <Text textAlign={'left'} fontWeight={'600'}>
            {title}
          </Text>
          <Text color={'gray'} fontWeight={'400'}>
            {subtitle}
          </Text>
        </Flex>
        <Spacer />
        <Box fontSize={'25px'}>{image}</Box>
      </Button>
    </Center>
  );
};

export default RegularButton;
